import endpoints, { axios } from "../../config/api";

async function getSubfolders(folderId: string) {
  return await (await axios.get(endpoints.newfolders.subfolders(folderId)))
    .data;
}

export default getSubfolders;
